export const timeToHHMMSS = seconds =>
  new Date(seconds * 1000).toUTCString().match(/(\d\d:\d\d:\d\d)/)[0]

export const formatDuration = seconds => {
  const h = Math.floor(seconds / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  const s = Math.round(seconds % 60)
  return [h, m > 9 ? m : h ? '00' + m : m || '00', s > 9 ? s : '0' + s].filter(Boolean).join(':')
}
